import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="scroll-to-top-btn"
      className="fixed bottom-6 right-6 z-50 w-10 h-10 sm:w-11 sm:h-11 bg-garden-800 hover:bg-garden-900 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-garden-600 focus:ring-offset-2"
      aria-label="Remonter en haut"
    >
      <ChevronUp size={20} />
    </button>
  );
}
